import { FilterBonusRefType, FilterReferenceUser } from "@reactive-resume/dto";
import { FilterCouponType } from "libs/dto/src/coupon";
import { FilterDownloadType } from "libs/dto/src/download";
import { FilterPaymentIntendType, FilterPaymentIntendTypeByAmbassador } from "libs/dto/src/payment";
import { FilterRateType } from "libs/dto/src/rate";
import { FilterWithdrawalType } from "libs/dto/src/withdrawal";
import { create } from "zustand";

export type FilterState<T = unknown> = {
  filter: T | null | undefined;
  setFilter: (params: T) => void;
  replaceFilter: (params: T | null) => void;
  resetFilter: () => void;
};

export const createFilterStore = <T = unknown>() =>
  create<FilterState<T>>()((set) => ({
    filter: null,
    setFilter: (params) =>
      set((state) => ({
        filter: {
          ...(state.filter || {}),
          ...params,
        },
      })),

    replaceFilter: (params) =>
      set((state) => ({
        filter: params,
      })),

    resetFilter: () => set((state) => ({ filter: null })),
  }));

export const useFilterReference = createFilterStore<FilterReferenceUser>();
export const useFilterBonusRef = createFilterStore<FilterBonusRefType>();
export const useFilterRate = createFilterStore<FilterRateType>();
export const useFilterCoupon = createFilterStore<FilterCouponType>();
export const useFilterWithdrawal = createFilterStore<FilterWithdrawalType>();
export const useFilterPayment = createFilterStore<FilterPaymentIntendType>();
export const useFilterDownload = createFilterStore<FilterDownloadType>();
export const useFilterTransactionForAmba = createFilterStore<FilterPaymentIntendTypeByAmbassador>();
